import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

const plansSlice = createSlice({
    name: "plans",
    initialState : {
        userPlans: {
            farmerPlan: {},
        }
    },
    reducers: {
        setUserFarmerPlan(state, action){
            state.userPlans.farmerPlan = action.payload;
        }
    }
});

const planSliceName = plansSlice.name;
const planReducer = plansSlice.reducer;
const usePlanStore = () => useSelector((state) => state.plans);
export const {setUserFarmerPlan} = plansSlice.actions;

export {
    planSliceName,
    planReducer,
    usePlanStore
}

